import {gql, useMutation} from "@apollo/client";

const REMOVE_TEAM_FROM_GROUP_MUTATION = gql`
mutation removeTeamFromGroup($groupId: Int, $stageId: Int!, $seasonId: Int!, $teamId: Int, $deleteGroup: Boolean = false) {
  removeTeamFromGroup(groupId: $groupId, stageId: $stageId, seasonId: $seasonId, teamId: $teamId, deleteGroup: $deleteGroup) {
     group{
        id
     }
  }
}
`;

export default function RemoveTeamFromGroupMutation() {
    return useMutation(REMOVE_TEAM_FROM_GROUP_MUTATION);
}